import {Box} from "@mui/material";
import ProfileTextfield from "./modues/ProfileTextfield";
import {useProfileContext} from "../../context/profile/ProfileContext";
import React, {useEffect, useMemo, useState} from "react";
import {sendData, updateData} from "../../lib/dashboard/actions";
import ProfileFormButtons from "./modues/ProfileFormButtons";
import {profileEmailSchema} from "../../validation";
import ProfileConfirmEmailCodeModal from "./modues/ProfileConfirmEmailCodeModal";
import Loading from "../../components/loader/Loading";

const ProfilePersonalInfo = ({editMode, setEditMode}) => {

    const {
        profileInfoData,
        isProfileInfoLoading,
    } = useProfileContext();

    const [personalInfoFormValues, setPersonalInfoFormValues] = useState({
        first_name: "",
        last_name: "",
        email: "",
        email_code: "",
        username: "",
    });
    const [isLoading, setIsLoading] = useState({
        personal_info: false,
        email: false,
        email_code: false
    });
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // set info's into the state
    useEffect(() => {
        if (profileInfoData) {
            setPersonalInfoFormValues({
                first_name: profileInfoData.first_name || "",
                last_name: profileInfoData.last_name || "",
                email: profileInfoData.email || "",
                email_code: "",
                username: profileInfoData.username || "",
            });
        }
    }, [profileInfoData]);

    // handler for switch edit mode
    const handleChange = (field) => (event) => {
        setPersonalInfoFormValues((prevValues) => ({
            ...prevValues,
            [field]: event.target.value,
        }));
    };

    //save personal information (first_name and last_name)
    const handleSavePersonalInfo = async () => {
        setIsLoading((prev => ({...prev, personal_info: true})));
        await updateData(
            {
                first_name: personalInfoFormValues.first_name,
                last_name: personalInfoFormValues.last_name,
            },
            "/account/profile",
            "PUT"
        );
        setEditMode(false);
        setIsLoading((prev => ({...prev, personal_info: false})));
    };

    //cancel and make back textfields value back to normal
    const handleCancel = () => {
        if (profileInfoData) {
            setPersonalInfoFormValues({
                first_name: profileInfoData.first_name || "",
                last_name: profileInfoData.last_name || "",
                email: profileInfoData.email || "",
                email_code: "",
                username: profileInfoData.username || "",
            });
        }
        setEditMode(false);
    };

    //validate email using useMemo to avoid unnecessary recalculations
    const isEmailValid = useMemo(() => {
        const result = profileEmailSchema.safeParse({email: personalInfoFormValues.email});
        return result.success;
    }, [personalInfoFormValues.email]);

    //new email registered and code comes for email
    const handleGetEmailVerificationCode = async () => {
        setIsLoading((prev => ({...prev, email: true})));
        const {status} = await sendData({email: personalInfoFormValues.email}, "/account/email")
        if (status === 200) handleOpen()
        if (status !== 200) handleOpen()
        setIsLoading((prev => ({...prev, email: false})));
    }

    //submit the code and email
    const handleSubmitEmailCode = async () => {
        setIsLoading((prev => ({...prev, email_code: true})));
        const {status} = await sendData({
            code: personalInfoFormValues.email_code
        }, "/account/email")
        setIsLoading((prev => ({...prev, email_code: false})));
        if (status === 200) {
            handleClose();
        }
    }

    return (
        <>
            {/*confirm email code modal*/}
            <ProfileConfirmEmailCodeModal
                open={open}
                handleClose={handleClose}
                personalInfoFormValues={personalInfoFormValues}
                handleChange={handleChange}
                handleSubmitEmailCode={handleSubmitEmailCode}
                loading={isLoading}
            />

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: {xs: "column", md: "row"},
                    gap: "20px",
                }}
            >
                <ProfileTextfield
                    label="نام"
                    type="text"
                    placeholder={isProfileInfoLoading ? "درحال بارگذاری" : ""}
                    value={personalInfoFormValues.first_name}
                    onChange={handleChange("first_name")}
                    disabled={!editMode}
                />
                <ProfileTextfield
                    label="نام خانوادگی"
                    type="text"
                    placeholder={isProfileInfoLoading ? "درحال بارگذاری" : ""}
                    value={personalInfoFormValues.last_name}
                    onChange={handleChange("last_name")}
                    disabled={!editMode}
                />
            </Box>
            <Box
                sx={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-end"
                }}
            >
                <ProfileTextfield
                    label="آدرس ایمیل"
                    type="email"
                    placeholder={isProfileInfoLoading ? "درحال بارگذاری" : ""}
                    value={personalInfoFormValues.email}
                    onChange={handleChange("email")}
                    disabled={!editMode}
                />
                {editMode && isEmailValid && (
                    <Box sx={{display: "flex", alignItems: "flex-end", gap: "10px"}}>
                        <button
                            onClick={handleGetEmailVerificationCode}
                            className="btn btn-blue"
                            style={{width: "100px", height: "46px"}}
                        >
                            {
                                isLoading.email ? (
                                    <Loading color="#fff"/>
                                ) : "ارسال کد"
                            }
                        </button>
                    </Box>
                )}
            </Box>
            <ProfileTextfield
                label="شماره موبایل (نام کاربری)"
                type="number"
                placeholder={isProfileInfoLoading ? "درحال بارگذاری" : ""}
                value={personalInfoFormValues.username}
                onChange={handleChange("username")}
                disabled
            />
            {editMode && (
                <ProfileFormButtons
                    submitForm={handleSavePersonalInfo}
                    cancelForm={handleCancel}
                    loading={isLoading.personal_info}
                />
            )}
        </>
    );
};

export default ProfilePersonalInfo;